import type { VatCalculations } from '../types/VatReturn';
import { useState } from 'react';
import { useForm } from '@mantine/form';

const defaultCalculations: VatCalculations = {};

export function useCalculationForm(currentInputs?: VatCalculations) {
	const [inputs, setInputs] = useState<VatCalculations>(
		currentInputs ?? defaultCalculations,
	);

	const form = useForm<VatCalculations>({
		mode: 'uncontrolled',
		initialValues: currentInputs ?? defaultCalculations,
		validate: {
			vatDue: (v) => !v  && 'Please insert value',
			vatDueOnAcquisitions: (v) => !v && 'Please insert value',
			vatReclaimed: (v) => !v && 'Please insert value',
			vatToReclaimFromCustoms: (v) => !v && 'Please insert value',
			totalVat: (v) => !v && 'Please insert valuee',
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
